import React, { useState } from "react";
import Button from "sushiweb/Button";
import {
  BottomSectionModal,
  NotesSection,
  UploadCsvOption,
} from "../../constants/assets/containers";
import { getBulkCities, getCity, getCityList } from "../../store/actions/City";
import { getDriverCategoryList } from "../../store/actions/DriverCategory";
import {
  getBulkLocalities,
  getLocality,
  getLocalityList,
} from "../../store/actions/Locality";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import NoFooterModal from "../Common/NoFooterModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FileUpload from "../Common/FileUpload";
import InformationBar from "../Common/InformationBar";
import Upload from "sushiweb/Icons/all/Upload";
import variables from "../../constants/assets/variables";
import {
  bulkUploadDriverIds,
  launchAppRelease,
} from "../../store/actions/DriverAppReleases";
import Textarea from "sushiweb/InputTypes/Textarea";
import { getDriverReleasedList } from "../../store/actions/DriverReleasedVersion";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const LaunchReleaseModal = ({
  appVersion,
  appReleaseId,
  handleModalClose,
  getCity,
  getCityList,
  getLocality,
  getLocalityList,
  cityList,
  localityList,
  nextPageCity,
  nextPageLocality,
  bulkUploadDriverIds,
  launchAppRelease,
  activeAppRelease,
}) => {
  const [priorityFlag, setPriorityFlag] = useState(false);
  const [callbackKey, setCallbackKey] = useState("");
  const [fileUploadUrl, setFileUploadUrl] = useState("");
  const [initialState, setInitialState] = useState({
    city_ids: [],
    locality_ids: [],
    categories: [],
    exclude_versions: [],
    release_notes: activeAppRelease.release_notes,
  });
  const [activeFile, setActiveFile] = useState("");

  const sampleCsvUrl = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_driver_id_app_launch.csv`
      : ""
  }`;

  const handleSubmit = () => {
    if (activeFile) {
      bulkUploadDriverIds({
        filename: activeFile.name,
        expected_app_version: appVersion,
      }).then((res) => {
        if (res) {
          setFileUploadUrl(res.file_upload_url);
          setCallbackKey(res.callback_key);
        }
      });
    } else {
      if (initialState.city_ids.length > 0) {
        const payload = { ...initialState };
        if (payload["release_notes"] === activeAppRelease.release_notes) {
          delete payload["release_notes"];
        }
        launchAppRelease(appReleaseId, payload).then((_) => {
          handleModalClose();
        });
      }
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    if (key == "city_ids") {
      setPriorityFlag(true);
      values["locality_ids"] = [];
    }
    setInitialState(values);
  };

  const handleFileChange = (file) => {
    setActiveFile(file);
  };

  const handleFileUploadSuccess = () => {
    const payload = { ...initialState };
    if (payload["release_notes"] === activeAppRelease.release_notes) {
      delete payload["release_notes"];
    }
    launchAppRelease(appReleaseId, {
      ...payload,
      callback_key: callbackKey,
    }).then((_) => {
      handleModalClose();
    });
  };

  return (
    <NoFooterModal
      header
      heading={`Launch release - ${appVersion}`}
      handleClose={handleModalClose}
      id="launchReleaseModal"
      modalButtons={
        <BottomSectionModal>
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Launch
          </Button>
        </BottomSectionModal>
      }
    >
      <InfiniteScrollDropdown
        id="cityDropdownAppRelease"
        multiple
        priorityFlag={true}
        appliedFilters={{}}
        getActiveList={getCityList}
        nextPage={nextPageCity}
        resKey="cities"
        modalState={"Edit"}
        keyName="city_ids"
        labelKey="city_name"
        getDataLabelKey="city.city_name"
        keyTypeToSet="id"
        label="Cities"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        getActiveItemById={getCity}
      />
      <InfiniteScrollDropdown
        id="localityDropdownAppRelease"
        multiple
        setPriorityFlag={setPriorityFlag}
        priorityFlag={priorityFlag}
        appliedFilters={
          initialState.city_ids ? { city_id: initialState.city_ids } : {}
        }
        getActiveList={getLocalityList}
        nextPage={nextPageLocality}
        resKey="localities"
        modalState={"Edit"}
        keyName="locality_ids"
        labelKey="locality_name"
        labels={["locality_name", "id"]}
        getDataLabelKey="locality.locality_name"
        keyTypeToSet="id"
        getActiveItemById={getLocality}
        label="Localities"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
      />
      <InfiniteScrollDropdown
        id="releasedApp_dropdown"
        multiple
        priorityFlag={true}
        appliedFilters={{}}
        getActiveList={getDriverReleasedList}
        resKey="releasedAppVersions"
        modalState={"Edit"}
        keyName="exclude_versions"
        labelKey="name"
        keyTypeToSet="name"
        label="Exclude app versions"
        handleChange={handleChange}
      />
      <InfiniteScrollDropdown
        id="category_dropdown"
        multiple
        priorityFlag={true}
        appliedFilters={{}}
        getActiveList={getDriverCategoryList}
        resKey="driverCategories"
        modalState={"Edit"}
        keyName="categories"
        labelKey="name"
        getDataLabelKey="driverCategories.name"
        keyTypeToSet="category"
        label="Launch Categories (Default selection is all, select to override)"
        handleChange={handleChange}
        data-testid="launchCategory"
      />
      <Textarea
        id="sushi-textarea"
        borderColor={variables.primaryColor}
        className="mb-30"
        innerWidth="100%"
        resize="none"
        label="Release notes"
        data-testid="versionReleaseNotes"
        onChange={(e) => handleChange("release_notes", e)}
        value={initialState.release_notes}
      />
      <FileUpload
        heading="Bulk upload rider FE Ids"
        UploadIcon={<Upload color={variables.black} />}
        activeFile={activeFile}
        setActiveFile={handleFileChange}
        noAckCall
        callback_key={callbackKey}
        presign_url={fileUploadUrl}
        handleFileUploadSuccess={handleFileUploadSuccess}
        acceptTypes=".csv, .xls, .xlsx"
        maxSize={10}
      />
      <NotesSection>
        <InformationBar sampleUrl={sampleCsvUrl} instructions={instructions} />
      </NotesSection>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { City, Locality, DriverAppReleases } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLocalityList: bindActionCreators(getLocalityList, dispatch),
    getCity: bindActionCreators(getBulkCities, dispatch),
    getLocality: bindActionCreators(getBulkLocalities, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
    getDriverCategoryList: bindActionCreators(getDriverCategoryList, dispatch),
    bulkUploadDriverIds: bindActionCreators(bulkUploadDriverIds, dispatch),
    launchAppRelease: bindActionCreators(launchAppRelease, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaunchReleaseModal);
